'use strict';

require('./performance-review-basis.scss');

module.exports = {
  template: require('./performance-review-basis.html'),
  controller: require('./performance-review-basis.controller'),
  controllerAs: 'vm',

  bindings: {
    data: '<',
    round: '<'
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/performance-review/performance-review-basis/index.js
 ** module id = 281
 ** module chunks = 0
 **/